export default __webpack_public_path__ + "static/media/reduce-waste.ab659208.png";